export { default } from './Spinner';



// WEBPACK FOOTER //
// ./src/design-system/atoms/Spinner/index.jsx